/**
 * Theme module public API.
 * Import from here, never from individual files.
 *
 *   import { useTheme, useColors, space, radius } from '@/shared/theme';
 */

export { ThemeProvider, useTheme, useColors } from './ThemeProvider';
export { palettes, tabToMode } from './colors';
export type { ColorPalette, ThemeMode } from './colors';
export { useLegacyC, adaptColors } from './legacyAdapter';
export type { LegacyColors } from './legacyAdapter';
export {
  space,
  radius,
  fontSize,
  fontWeight,
  letterSpacing,
  motion,
  size,
  shadow,
  zIndex,
} from './tokens';
export type { SpaceKey, RadiusKey } from './tokens';
